import { BaseIntegration, BaseIntegrationState } from '@/models/integrations/BaseIntegration';
import { Component } from 'vue';
import { IntegrationOpenIdConnectData } from './Data';

export interface IntegrationOpenIdConnectState extends BaseIntegrationState {
  loginUrl?: string;
  fieldsMapped?: number[];
}

export class IntegrationOpenIdConnectModel extends BaseIntegration<
  IntegrationOpenIdConnectData,
  IntegrationOpenIdConnectState
> {
  parse(data: IntegrationOpenIdConnectData) {
    super.parse(data);
    this.state.loginUrl = data.settings?.openid_connect_login_url;
    this.state.fieldsMapped = data.settings?.openid_connect_fields_mapped ?? [];
  }

  getVueComponent(): Promise<Component> {
    return import('@/components/integrations/open-id-connect/View.vue');
  }

  hasVueComponent() {
    return true;
  }

  authorSignature(): string {
    return 'Ani Mikova';
  }
}
